import React from 'react';
import { ButtonsGroups } from './style';

function DemoButtons() {
	return (
		<>
		{/* <ButtonsGroups>
			<button type="submit" className="button-outline btn1" onClick={() => {}}>
				Get Started
			</button>

		 	<button type="submit" className="button-outline btn2" onClick={() => {}}>
	 		Request a Demo
			</button>
		</ButtonsGroups> */}
		</>
	);
}

export default DemoButtons;
